<mat-basic-chip
    [removable]="isChipRemovable"
    [disableRipple]="true"
    [euiTooltip]="tooltipMessage"
    [euiTooltipPrimary]="data && data.tooltip && data.tooltip.color==='euiTooltipPrimary'"
    [euiTooltipSecondary]="data && data.tooltip && data.tooltip.color==='euiTooltipSecondary'"
    [euiTooltipInfo]="data && data.tooltip && data.tooltip.color==='euiTooltipInfo'"
    [euiTooltipSuccess]="data && data.tooltip && data.tooltip.color==='euiTooltipSuccess'"
    [euiTooltipWarning]="data && data.tooltip && data.tooltip.color==='euiTooltipWarning'"
    [euiTooltipDanger]="data && data.tooltip && data.tooltip.color==='euiTooltipDanger'"
    [euiTooltipAccent]="data && data.tooltip && data.tooltip.color==='euiTooltipAccent'"
    [position]="data && data.tooltip && data.tooltip.position ? data.tooltip.position : 'above'"
    [content]="data && data.tooltip && data.tooltip.contentAlignment ? data.tooltip.contentAlignment : 'center'"
    [content]="data && data.tooltip && data.tooltip.contentAlignment ? data.tooltip.contentAlignment : 'center'"
    [euiTooltipRounded]="data && data.tooltip && data.tooltip.rounded ? true : false"
    [euiTooltipArrows]="data && data.tooltip && data.tooltip.arrows ? true : false"
    (removed)="onRemove()">
    <div class="eui-chip__content-container" #chipLabel>
        <ng-content></ng-content>
    </div>
    <span *ngIf="isChipRemovable" matChipRemove euiIcon iconClass="eui-chip__remove-icon eui-icon eui-icon-times-circle-thin"></span>
</mat-basic-chip>
